import React from 'react';
import MuiButton from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { ButtonProps } from './Button.props';
import { ButtonStyles } from './Button.styles';

function ProgressIcon() {
  return <CircularProgress color='inherit' size={22} sx={{ mr: 0.5 }} />;
}

// eslint-disable-next-line react/function-component-definition
const Button: React.FC<ButtonProps> = ({
  alternate,
  neutral,
  progress = false,
  ...props
}: ButtonProps) => (
  <MuiButton
    {...ButtonStyles}
    {...props}
    variant={alternate ? 'outlined' : 'contained'}
    color={neutral ? 'secondary' : props.color}
    startIcon={!progress && props.startIcon}
    endIcon={progress ? <ProgressIcon /> : props.endIcon}
    disableElevation>
    {props.children}
  </MuiButton>
);

export default Button;
